import { useMutation, useQueryClient } from "@tanstack/react-query";
import giftCategoriesClient, {
  GiftCategory,
} from "../../../../api/giftCategories";

interface UseUpdateCategoryMutationOptions {
  onSuccess?: (
    data: void,
    variables: Partial<GiftCategory> & { _id: string },
  ) => void;
  onError?: (
    error: unknown,
    variables: Partial<GiftCategory> & { _id: string },
  ) => void;
}

const useUpdateCategoryMutation = (
  options?: UseUpdateCategoryMutationOptions,
) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["categories"],
    mutationFn: (category: Partial<GiftCategory> & { _id: string }) => {
      return giftCategoriesClient.updateCategory(category._id, category);
    },
    onSuccess: (data, variables) => {
      options?.onSuccess?.(data, variables);

      queryClient.invalidateQueries({
        queryKey: ["categories"],
      });
    },
    onError: (error, variables) => {
      options?.onError?.(error, variables);
    },
  });
};
export default useUpdateCategoryMutation;
